// Functierollen uit de rapportage-template (voorblad belanghebbenden).
// Eén bron voor sessiebalk, gebruikersbeheer en gemeente-ambtenaren.
export const ROLLEN = [
  'Omgevingsmanager Stedin (regisseur)',
  'Key Account Manager Stedin',
  'Adviseur Omgevingscommunicatie Stedin',
  'Engineer Stedin',
  'Grondzaken Stedin',
  'Coördinator gemeente (regisseur)',
  'Ruimtelijke ordening gemeente',
  'Stedenbouwkundige gemeente',
  'Vergunningen gemeente',
  'Groen gemeente',
  'Verkeer gemeente',
  'Omgevingsmanager Aannemer',
];
